import React from 'react';
import { useSlate } from 'slate-react';
import { Editor } from './Editor';
import { ExternalEditorToolbar } from './ExternalEditorToolbar';

export const EditorToolbar: React.FC = () => {
  const editor = useSlate() as Editor;
  return <ExternalEditorToolbar editor={editor} />;
};
